
import React from 'react'
import { useLocation, useParams } from 'react-router-dom';


/**
 * SaveEllipseData
 * Props:
 * - ellipseData: object or array — 保存する楕円データ（JSON シリアライズ可能）
 * - defaultName: string — ダウンロード時のデフォルトファイル名（拡張子不要）
 * - onSaved: function(name) — 保存完了時のコールバック
 */


export default function SaveEllipseData( { ellipseInfo = {}, userId = null }) {
    // Hooks must be called at component top-level
    const { state } = useLocation();
    const params = useParams();
    const effectiveUserId = userId ?? (state?.userId ?? (params?.userId ? parseInt(params.userId, 10) : null));
    const defaultName = effectiveUserId !== null && effectiveUserId !== undefined ? String(effectiveUserId) : 'ellipse_data';

	const handleSave = async () => {
		if (!ellipseInfo) {
			window.alert('保存する楕円データが見つかりません。');
			return;
		}
		const name = window.prompt('保存するファイル名を入力してください（拡張子不要）', defaultName);
		if (!name) return;

		 try {
			const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
			const response = await fetch(`${apiUrl}/save-ellipse-data`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ ellipses: ellipseInfo , filename: name}),
			});
			if (!response.ok) {
			throw new Error('Network response was not ok');
			}
			const data = await response.json();
			// 必要に応じてデータを処理
			console.log('サーバーからの応答:',data);
		} catch (error) {
			console.error('Error:', error);
		}
	};

	return (
		<button
				type="button"
				onClick={handleSave}
				className="btn btn--secondary"
				title="検出した楕円データをJSONで保存します"
			>
			楕円データを保存
		</button>
	);
}
